import React from 'react';
interface ScreenContainerProps {
  children: React.ReactNode;
  width?: 'narrow' | 'wide';
}
export function ScreenContainer({
  children,
  width = 'wide'
}: ScreenContainerProps) {
  return <section className={`anim-enter mx-auto w-full px-4 py-8 sm:px-6 sm:py-10 ${width === 'narrow' ? 'max-w-3xl' : 'max-w-6xl'}`} data-id="element-548" data-mp="3vdassf2zlm8s">
      {children}
    </section>;
}